import React, { useEffect } from 'react';
import { Card, Panel, Button } from '@/components/Bicester';
import { GePcsList, ReadyContext } from '@/providers/ReadyProvider';
import { FormikContextType } from 'formik';
import { SuggestInfo } from './constants';

const Result = ({
  formik,
  casesBasic,
  gePcsList,
  setDefaultInfo,
}: {
  formik: FormikContextType<any>;
  casesBasic: any;
  gePcsList: GePcsList;
  setDefaultInfo?: (value: SuggestInfo) => void;
}) => {
  const { profile } = React.useContext(ReadyContext);

  useEffect(() => {
    const isGe = gePcsList.ge_list?.find((ge) => ge.label === profile?.user_name);
    if (isGe) {
      setDefaultInfo({
        ...formik.initialValues,
        dispose_ge_id: isGe.value,
      });
    }
  }, []);

  return (
    <Panel title="处理结果" leftShadow>
      <Card smDivider>
        <div className="flex">
          <Card.Picker
            required
            label="投诉处理状态"
            formKey="cases_status"
            pickerData={casesBasic.cases_status}
          />
          <Card.Picker
            label="处理大使"
            formKey="dispose_ge_id"
            pickerData={gePcsList.ge_list}
            searchable
            placement="topStart"
          />
          <Card.Picker
            label="协助零售经理"
            formKey="dispose_retail_id"
            pickerData={casesBasic.retails}
            searchable
            placement="topStart"
          />
          <Card.CheckPicker
            label="赔偿内容"
            formKey="cases_dispose"
            pickerData={casesBasic.dispose_type}
            searchable
            placement="topEnd"
          />
        </div>
        <div className="flex">
          <Card.Input
            label="处理详情"
            formKey="dispose_remark"
            inputType="textarea"
            labelWeight={1}
            contentWeight={7}
          />
        </div>
      </Card>
      <div className="flex justify-end mt-[20px]">
        <Button type="submit" className="px-[70px]">
          确认提交
        </Button>
      </div>
    </Panel>
  );
};

export default Result;
